<div *ngIf="question?.columns && question?.rows" class="table">
    <div class="header">
        <div class="column border-radius-r-t"  [style.background]="secondaryColor$ | async"></div>
        <div class="column" [style.background]="secondaryColor$ | async"
         *ngFor="let tq of question?.columns ; let i=index" [ngClass]="{'border-radius-l-t':i+1==question?.columns?.length}">{{tq.title}}</div>
    </div>
    <div  class="row" *ngFor="let row of question?.rows; let j = index" >
        <div class="answer" [ngClass]="{'border-radius-r-b':j+1==question?.rows?.length}">{{row.title}}</div>
        <div class="answer" *ngFor="let tq of question?.columns;let i =index" 
        [ngClass]="{'border-radius-l-b':(j+1==question?.rows?.length) && (i+1==question?.columns?.length)}"
        (click)="choose(i, j)">
            <div class="checkbox" [ngClass]="{'checked':tq.value}">
                <div class="img"   *ngIf="arr[i]?.[j] === true" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 16 12" fill="none">
                        <path
                            d="M5.54993 11.6539L0.215332 6.3193L1.28456 5.2501L5.54993 9.51547L14.7153 0.350098L15.7845 1.4193L5.54993 11.6539Z"
                            fill="#F05612" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
<!-- 
    <div *ngFor="let row of arr2; let j = index"   class="row">
        <div *ngFor="let col of arr3; let i = index" (click)="choose(i, j)"  class="answer">
          <img src=".../../../../checked" *ngIf="arr[i]?.[j] === true" alt="Checked Image">
        </div>
      </div>
       -->
</div>